function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_5776",
  "data-name": "Rectangle 5776",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Exclusion_2",
  "data-name": "Exclusion 2",
  d: "M16.024,16.814H2.232A2.159,2.159,0,0,1,0,14.584a2.311,2.311,0,0,1,.3-1.09L7.2,1.145a2.2,2.2,0,0,1,3.858,0l6.911,12.34a2.311,2.311,0,0,1,.288,1.1,2.159,2.159,0,0,1-2.233,2.229Zm-7-4.971a.983.983,0,1,0,.725.261.974.974,0,0,0-.725-.261Zm-.005-6.88a.934.934,0,0,0-.681.264.831.831,0,0,0-.224.621l.119,4.236a.728.728,0,0,0,.791.785.712.712,0,0,0,.775-.785l.134-4.227A.854.854,0,0,0,9.7,5.23a.936.936,0,0,0-.681-.267Z",
  transform: "translate(2.869 3.514)",
  fill: "#f1c40f"
});

function SvgWarningFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning_filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning_filled.ab43a8c5.svg";
export { ForwardRef as ReactComponent };